// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2Rzwm","emails":"CreateEditClinics_emails__3vHu2","emailTagLabel":"CreateEditClinics_emailTagLabel__1z4bd"};